import {Tabs} from "antd";
import styled from "styled-components";

export const TabsContainer = styled(Tabs)`
    @media (max-width: 768px) {
        .ant-tabs-nav {
            .ant-tabs-nav-wrap {
                .ant-tabs-nav-list {
                    display: flex;
                    flex-direction: row;
                }
            }
        }
    }
`;
